import moment from 'moment';
import { getters } from '@/modules/core/app/helpers/store';

export class BaseDateRangeConfig {
  /**
   * @type {Array.<RelativeDateRange>}
   */
  relativeRanges;

  constructor() {
    this.relativeRanges = {};

    // Additional NON-datarangepicker props
    if (getters.daterange && getters.daterange.getRelativeDateRanges) {
      this.relativeRanges = getters?.daterange?.getRelativeDateRanges();
    }
  }

  /**
   * @param key
   * @returns {{start: moment.Moment, end: moment.Moment}}
   */
  getDateRangeFromRelativeRange(key) {
    const relativeRanges = getters.daterange.getRelativeDateRanges() ?? this.relativeRanges ?? {};
    const selectedRange = relativeRanges[key];

    const startDate = selectedRange ? selectedRange.start : '';
    const endDate = selectedRange ? selectedRange.end : '';

    return {
      key,
      start: moment(startDate),
      end: moment(endDate),
    };
  }
}

export default new BaseDateRangeConfig();
